
import component1             from '@/components/stat/SellOut_AllSuppliersCollection.vue'
//import component2             from '@/components/stat/SellOutSupplierCategory.vue'
import component3             from '@/components/stat/SellOutSupplierProduct.vue'
import component4             from '@/components/stat/SellOut_SupplierCollection.vue'
//import component4             from '@/components/stat/SellOutSupplierProductCollection.vue'

const menuId = 'rp2'
const routes = [
    {
        path        : '/report2/component1',
        name        : 'sellout1',
        component   : component1,
        meta        : { name : 'Tutti i Fornitori per Collezione',component : true, visible : true ,icon : 'fas fa-user-friends',menu:menuId,color : '#6666FF'},

    },
    /*
    {
        path        : '/report2/component2',
        name        : 'sellout2',
        component   : component2,
        meta        : { name : 'Fornitore/Categoria', visible : true ,icon : 'fas fa-chart-bar',menu:menuId,color : '#6666FF'},

    },
    */
/*
    {
        path        : '/report2/component3',
        name        : 'sellout3',
        component   : component3,
        meta        : { name : 'Fornitore/Prodotti', visible : true ,icon : 'fas fa-chart-pie',menu:menuId,color:'#6666FF'}

    },
    */
    {
        path        : '/report2/component4',
        name        : 'sellout4',
        component   : component4,
        meta        : { name : 'Fornitore/Prodotti per Collezione',component : true, visible : true ,icon : 'fas fa-user-alt',menu:menuId,color:'blue'}

    },
    {
        path        : '/report2/component3',
        name        : 'sellout3',
        component   : component3,
        meta        : { name : 'Acquistato/venduto per fornitore nel periodo',component : false, visible : true ,icon : 'fas fa-chart-pie',menu:menuId,color:'#6666FF'}

    },

    

    
        
]
export default routes